export const carousel = [
  {
    id: 1,
    image:
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=1920&q=85',
    text: 'Premium pre-owned SUVs, ready for your next drive.',
    kicker: 'Verified used cars',
    subtext: 'Handpicked listings with inspection reports and transparent pricing.',
  },
  {
    id: 2,
    image:
      'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?auto=format&fit=crop&w=1920&q=85',
    text: 'Browse sedans, hatchbacks & SUVs in one place.',
    kicker: 'Wide selection',
    subtext: 'Compare real cars from trusted sellers across every budget.',
  },
  {
    id: 3,
    image:
      'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1920&q=85',
    text: 'Drive home a quality-checked car with confidence.',
    kicker: 'Inspected & certified',
    subtext: '200+ point checks, warranty options, and easy finance support.',
  },
  {
    id: 4,
    image:
      'https://images.unsplash.com/photo-1609521263047-f8f205293f24?auto=format&fit=crop&w=1920&q=85',
    text: 'Find the perfect family car at the right price.',
    kicker: 'Best value deals',
    subtext: 'Low EMI options and hassle-free RC transfer assistance.',
  },
  {
    id: 5,
    image:
      'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=1920&q=85',
    text: 'Sell your car faster with instant valuation support.',
    kicker: 'Sell with ease',
    subtext: 'List online, reach serious buyers, and close deals quicker.',
  },
];

export const heroType = [
  {
    id: 1,
    name: 'Buy Used Car',
  },
  {
    id: 2,
    name: 'Sell Your Car',
  },
  {
    id: 3,
    name: 'Car Valuation',
  },
];
